// constants
import { REPEAT_VALUES, EACH_PERIOD_ENDS_TYPE_OPTIONS } from 'constants/index'
import { KPI_RESULT_TYPE_VALUES } from 'constants/kpi'
// utils
import { isUuid } from 'utils/uuid'
import { find, join, lowerCase, map, pipe, isEmpty } from 'lodash/fp'
import pluralize from 'pluralize'
import { safeGetOr } from '../fp'

export const generateScaleLabel = (options = []) => pipe(map('label'), join(', '), (string) => `(${string})`)(options)

export const generateRecurrenceLabel = (data) => {
  if (isEmpty(data)) {
    return null
  }

  const { eachPeriodEndsType, repeatEveryType, repeatEveryValue, days } = data

  const type = pipe(lowerCase, (string) => string.slice(0, -2))(repeatEveryType)

  let displayValue = `Every ${repeatEveryValue} ${pluralize(type, parseInt(repeatEveryValue, 10))} on`

  if (repeatEveryType === REPEAT_VALUES.WEEKLY) {
    displayValue = `${displayValue} ${days.join(', ')}`
  }

  if (repeatEveryType === REPEAT_VALUES.MONTHLY) {
    const repeatOn = pipe(
      find(({ value }) => value === eachPeriodEndsType),
      safeGetOr('', 'label'),
      lowerCase
    )(EACH_PERIOD_ENDS_TYPE_OPTIONS)

    displayValue = `${displayValue} ${repeatOn}`
  }

  return displayValue
}

export const generateScaleOptions = (data) =>
  data.filter(({ active }) => active).map(({ id, label }) => ({ label, value: id }))

export const getScaleOptionValue = (value, resultType, resultTypeScale) => {
  let resultValue = { label: value, value }

  if (resultType === KPI_RESULT_TYPE_VALUES.SCALE || isUuid(resultValue.value)) {
    resultValue = resultTypeScale.find(({ id }) => id === value)
  }

  if (!resultValue) {
    resultValue = { label: value, value }
  }
  return resultValue
}
export * from './recurrence'
export * from './results'
export * from './resultTargets'
